import { createFileRoute } from "@tanstack/react-router";
import { loadBlockPage } from "~/utils/content-fns";
import { BlockRenderer } from "~/components/blocks";
import { seo, seoLinks } from "~/utils/seo";

export const Route = createFileRoute("/industry/$slug")({
  loader: async ({ params }) => {
    const page = await loadBlockPage({ data: { collection: "industry", slug: params.slug } });
    return { title: page.title, seo_title: page.seo_title, seo_description: page.seo_description, featured_image: page.featured_image, slug: page.slug, blocks: page.blocks || [] };
  },
  head: ({ loaderData }) => ({ meta: loaderData ? seo({ title: loaderData.seo_title || loaderData.title, description: loaderData.seo_description, image: loaderData.featured_image, url: `/industry/${loaderData.slug}` }) : [], links: loaderData ? seoLinks({ url: `/industry/${loaderData.slug}` }) : [] }),
  component: () => { const p = Route.useLoaderData(); return <BlockRenderer blocks={p.blocks} />; },
});
